

import Dashboard from "../pages/Dashboard/dasboard";
import Tutor from "../pages/People/TutorManagement/Tutor/Tutor"

import Students from "../pages/People/StudentManagement/Students/students";
import StudentDetails from "../pages/People/StudentManagement/StudentDetails/details"
import Administrators from '../pages/People/AdminManagement/admin'
import AdminDetails from "../pages/People/AdminManagement/AdminDetails/details"
import AdminAdd from "../pages/People/AdminManagement/AdminAdd/index"
import AddTutor from "../pages/People/TutorManagement/AddTutor"
import TurtorDetails from "../pages/People/TutorManagement/TutorDetails"
import StudentAdd from "../pages/People/StudentManagement/StudentAdd"
import Parent from "../pages/People/Parent/Parent"
import ParentDetails from "../pages/People/Parent/parentDetails/index"
import ParentAdd from "../pages/People/Parent/AddParent"
import Categories from "pages/Categories/index"
import AddCategory from "../pages/Categories/addCategory"
import Courses from "../pages/course/course/index"
import AddCourse from "../pages/course/addcourse"
import StudentRegistrationDetails from "../pages/Registrations/details/details"
import AddRegistration from '../pages/Registrations/NewRegistrations/Add/index'
import Newregistrations from '../pages/Registrations/NewRegistrations/Page'
import Demo from "../pages/Demo/demo/demo"
import CreateBatch from "../pages/Batches/schedulebatch"
import Batch from "../pages/Batches/Batches"
import Details from '../pages/Batches/details/details'
import ScheduleClasses from '../pages/scheduledClasses/classes'
import ClassesDetails from '../pages/scheduledClasses/details/details'
import ScheduleClassAdd from "../pages/Batches/createClasses"
import Enquiry from "../pages/EnquiryForm/enquiry"
import ContactUs from "../pages/ContactUS"
import Complaint from "../pages/Complaints"
import Roles from "../pages/Roles/roles"
import AddRole from "../pages/Roles/addRole"
import Notifications from "../pages/Notifications/notifications"
import Approval from "../pages/Approval/index"
import Calender from "../pages/Calender"
import ActivityLog from "../pages/ActivityLog/log"

import LessonPlan from "../pages/course/LessonPlan/lessonPlan"
import AddLessonPlan from "../pages/course/LessonPlan/addLessonPlan"
import Login from "../pages/Login/index"
import Resources from "../pages/Resource/index"
import AddupdateResource from "../pages/Resource/Add"
import TutorAvailability from '../pages/TutorAvailability/Availability'
import BulkCancel from "../pages/BulkCancel/cancel"
import Config from '../pages/Config/config/index'
import AddConfig from '../pages/Config/addconfig'
import Reports from 'pages/Reports'
import ParentCreditReport from 'pages/Reports/ParentCreditReport'
import TeacherManualAdjustmentReport from 'pages/Reports/TeacherManualAdjustmentReport'
import BatchFinishedReport from 'pages/Reports/BatchFinishedReport'
import TotalCustomerReport from 'pages/Reports/TotalCustomerReport'
import BulkPayouts from 'pages/BulkPayouts/DraftPayouts'
import PayoutDetails from 'pages/BulkPayouts/PayoutDetails'
import CreateBulk from 'pages/BulkPayouts/payouts'
import AddDemoRequest from 'pages/DemoClasses/addDemo/index'
import AddDemoStudent from 'pages/Demo/addDemoStudent'
import DemoClasses from 'pages/DemoClasses/demo'
import DemoClassesDetails from 'pages/DemoClasses/Details/details'
import Demorequest from 'pages/DemoReports/index'
import Cancellationreport from 'pages/CancelltionReport/report'
import TutorCancel from "pages/TutorCancel/Cancel"
import ClassTakenReport from 'pages/ClassTakenReport/report'
import EditRegistration from 'pages/Registrations/enrolled/edit/index'
import RegistrationDetails from 'pages/Registrations/details/details'
import CareerRoles from 'pages/Career/roles/roles'
import CareerOpenings from 'pages/Career/opening/opening'
import CareerApplications from 'pages/Career/applications/application'
import AddCareerRole from 'pages/Career/roles/Add'
import AddOpenings from 'pages/Career/opening/Add'
export const AccessKeys = {
    Dashboard: 'Dashboard',
    // DemoClassDetails:'Demo'
    Administrators: 'Administrators',
    Tutor: 'Tutor',
    Students: 'Students',
    Parents: 'Parents',
    Categories: 'Categories',
    Courses: 'Courses',
    "New Registrations": "new Registration",
    "Batch Created": "Batch Created",
    "Demo Requests": "Demo Requests",
    'Demo Classes': "Demo Classes",
    Batches: "Batches",
    "Cancellation Reports": "Cancellation Reports",
    "Scheduled Classes": "Scheduled Classes",
    Enquiry: "Enquiry",
    'Contact us': 'Contact Us',
    Complaints: 'Complaints',
    Roles: 'Roles',
    Notifications: 'Notifications',
    Approval: "Approval",
    Calender: 'Calender',
    Resources: 'Resources',
    Login: 'login',
    TutorAvailability: 'Tutor Availability',
    Public_holiday: 'Public Holiday',
    Tutor_requested_cancellation: 'Requested by teacher',
    Config: 'Configuration',
    Reports: 'Sales Reports',
    BulkPayout: "Bulk Payouts",
    DemoReports: "Demo Reports",
    "Added Registration": "Added Registration",
    "Career Roles": "Career Roles",
    "Openings": "Openings",
    "Applications": "Applications",
    "ClassTakenReport": "Class Taken Report",
    "Parent Credit Report": "Parent Credit Report",
    "Teacher Manual Adjustment Report": "Teacher Manual Adj. Report",
    "Batch Finished Report": "Batch Finished Report",
    "Total Customer Report": "Total Customer Report"
}


export const PageRoutes = [


    { path: '/', element: <Login />, AccessKey: AccessKeys.Login, Type: 'read' },
    { path: '/demo-reports', element: <Demorequest />, AccessKey: AccessKeys["DemoReports"], Type: 'read' },
    { path: '/class-taken-report', element: <ClassTakenReport />, AccessKey: AccessKeys["ClassTakenReport"], Type: 'read' },
    { path: '/career/roles', element: <CareerRoles />, AccessKey: AccessKeys["Career Roles"], Type: 'read' },
    { path: '/career/roles/:type', element: <AddCareerRole />, AccessKey: AccessKeys["Career Roles"], Type: 'write' },
    { path: '/career/openings', element: <CareerOpenings />, AccessKey: AccessKeys["Openings"], Type: 'read' },
    { path: '/career/openings/:type', element: <AddOpenings />, AccessKey: AccessKeys["Openings"], Type: 'write' },
    { path: '/career/applications', element: <CareerApplications />, AccessKey: AccessKeys["Applications"], Type: 'read' },

    { path: '/Dashboard', element: <Dashboard />, AccessKey: AccessKeys.Dashboard, Type: 'read' },

    { path: '/Student-registration/new-registration', element: <Newregistrations Type={'registration_new_created'} />, AccessKey: AccessKeys["New Registrations"], Type: 'read' },

    { path: '/Student-registration/Added-registration', element: <Newregistrations Type={'registration_Added'} />, AccessKey: AccessKeys["Added Registration"], Type: 'read' },

    { path: '/Student-registration/Batch-created', element: <Newregistrations Type={'registration_batch_created'} />, AccessKey: AccessKeys["Batch Created"], Type: 'read' },

    { path: '/Student-registration/details', element: <RegistrationDetails />, AccessKey: true, Type: 'read' },


    { path: '/Student-registration/new-registration/add', element: <AddRegistration />, AccessKey: AccessKeys["Added Registration"], Type: 'write' },
    { path: '/Student-registration/new-registration/edit/:id', element: <EditRegistration />, AccessKey: true, Type: 'edit' },




    { path: '/Administrators', element: <Administrators />, AccessKey: AccessKeys.Administrators, Type: 'read' },

    { path: '/administrator/add', element: <AdminAdd />, AccessKey: AccessKeys.Administrators, Type: 'write' },

    { path: '/Update-admin', element: <AdminAdd />, AccessKey: AccessKeys.Administrators, Type: 'write' },

    { path: '/Administrators/details', element: <AdminDetails />, AccessKey: AccessKeys.Administrators, Type: 'read' },

    { path: '/Tutor', element: <Tutor />, AccessKey: AccessKeys.Tutor, Type: 'read' },

    { path: '/Tutor/Add', element: <AddTutor />, AccessKey: AccessKeys.Tutor, Type: 'write' },

    { path: '/Tutor/update', element: <AddTutor />, AccessKey: AccessKeys.Tutor, Type: 'write' },

    { path: '/Tutor/Details', element: <TurtorDetails />, AccessKey: AccessKeys.Tutor, Type: 'read' },

    { path: '/Students', element: <Students />, AccessKey: AccessKeys.Students, Type: 'read' },
    { path: '/student/add', element: <StudentAdd />, AccessKey: AccessKeys.Students, Type: 'write' },

    { path: '/student/update', element: <StudentAdd />, AccessKey: AccessKeys.Students, Type: 'write' },

    { path: '/Students/details', element: <StudentDetails />, AccessKey: AccessKeys.Students, Type: 'read' },

    { path: '/Parent', element: <Parent />, AccessKey: AccessKeys.Parents, Type: 'read' },

    { path: '/Parent/Add', element: <ParentAdd />, AccessKey: AccessKeys.Parents, Type: 'write' },

    { path: '/Parent/Update', element: <ParentAdd />, AccessKey: AccessKeys.Parents, Type: 'write' },

    { path: '/parent/Details', element: <ParentDetails />, AccessKey: AccessKeys.Parents, Type: 'read' },

    { path: '/categories', element: <Categories />, AccessKey: AccessKeys.Categories, Type: 'read' },
    { path: '/categories/:category', element: <AddCategory />, AccessKey: AccessKeys.Categories, Type: 'write' },
    { path: '/courses', element: <Courses />, AccessKey: AccessKeys.Courses, Type: 'read' },
    { path: '/courses/Lessonplan', element: <LessonPlan />, AccessKey: AccessKeys.Courses, Type: 'read' },

    { path: '/courses/Lessonplan/Add', element: <AddLessonPlan />, AccessKey: AccessKeys.Courses, Type: 'write' },
    { path: '/courses/:addupdate', element: <AddCourse />, AccessKey: AccessKeys.Courses, Type: 'write' },

    // { path: '/Student-registration', element: <Enrolled />, AccessKey: AccessKeys['Student Registrations'], Type: 'read' },

    /* { path: '/Student-registration/details', element: <StudentRegistrationDetails />, AccessKey: AccessKeys['Student Registrations'], Type: 'read' },
    { path: '/Student-reigistration/Add', element: <AddRegistration />, AccessKey: AccessKeys['Student Registrations'], Type: 'write' },
    */
    // { path: '/edit-enroll/:id', element: <Editenroll />, AccessKey: AccessKeys['Student Registrations'], Type: 'edit' },

    { path: '/demo', element: <Demo />, AccessKey: AccessKeys['Demo Requests'], Type: 'read' },


    { path: '/add-demo-student', element: <AddDemoStudent />, AccessKey: AccessKeys['Demo Requests'], Type: 'write' },
    { path: '/edit-demo-class/:id', element: <AddDemoRequest />, AccessKey: AccessKeys['Demo Requests'], Type: 'edit' },
    { path: '/demo-classes', element: <DemoClasses />, AccessKey: AccessKeys['Demo Classes'], Type: 'read' },

    { path: '/add-demo-class', element: <AddDemoRequest />, AccessKey: AccessKeys['Demo Classes'], Type: 'write' },
    { path: '/Batches', element: <Batch />, AccessKey: AccessKeys.Batches, Type: 'read' },

    { path: '/Batches/add', element: <CreateBatch />, AccessKey: AccessKeys.Batches, Type: 'write' },

    { path: '/Batches/update', element: <CreateBatch />, AccessKey: AccessKeys.Batches, Type: 'write' },

    { path: '/Batches/Details', element: <Details />, AccessKey: AccessKeys.Batches, Type: 'read' },

    { path: '/scheduledClasses', element: <ScheduleClasses />, AccessKey: AccessKeys['Scheduled Classes'], Type: 'read' },

    { path: '/scheduledClasses/Details', element: <ClassesDetails />, AccessKey: AccessKeys['Scheduled Classes'], Type: 'read' },

    { path: '/scheduleClass/add', element: < ScheduleClassAdd />, AccessKey: AccessKeys["Scheduled Classes"], Type: 'write' },

    { path: '/enquiryForm', element: < Enquiry />, AccessKey: AccessKeys.Enquiry, Type: 'read' },

    { path: '/contact-us', element: < ContactUs />, AccessKey: AccessKeys['Contact us'], Type: 'read' },

    { path: '/complaint', element: < Complaint />, AccessKey: AccessKeys.Complaints, Type: 'read' },

    { path: '/roles', element: < Roles />, AccessKey: AccessKeys.Roles, Type: 'read' },

    { path: '/AddRole', element: < AddRole />, AccessKey: AccessKeys.Roles, Type: 'write' },
    { path: '/cancellation-report', element: < Cancellationreport />, AccessKey: AccessKeys["Cancellation Reports"], Type: 'write' },

    { path: '/editRole', element: < AddRole />, AccessKey: AccessKeys.Roles, Type: 'write' },

    { path: '/Notifications', element: < Notifications />, AccessKey: AccessKeys.Notifications, Type: 'read' },

    { path: '/Approvals', element: < Approval />, AccessKey: AccessKeys.Approval, Type: 'read' },

    { path: '/Calender', element: < Calender />, AccessKey: AccessKeys.Calender, Type: 'read' },

    { path: '/Resource', element: < Resources />, AccessKey: AccessKeys.Resources, Type: 'read' },

    { path: '/Resource/:Type', element: < AddupdateResource />, AccessKey: AccessKeys.Resources, Type: 'write' },
    { path: '/Tutor-availability', element: < TutorAvailability />, AccessKey: AccessKeys.TutorAvailability, Type: 'read' },
    { path: '/bulk-cancel', element: < BulkCancel />, AccessKey: AccessKeys.bulkCancel, Type: 'write' },
    { path: '/Tutor-cancel/Public_holiday', element: < TutorCancel />, AccessKey: AccessKeys.Public_holiday, Type: 'write' },
    { path: '/Tutor-cancel/Tutor_required', element: < TutorCancel />, AccessKey: AccessKeys.Tutor_requested_cancellation, Type: 'write' },
    { path: '/config', element: < Config />, AccessKey: AccessKeys.Config, Type: 'read' },
    { path: '/config/add', element: < AddConfig />, AccessKey: AccessKeys.Config, Type: 'write' },
    { path: '/config/edit', element: < AddConfig />, AccessKey: AccessKeys.Config, Type: 'edit' },
    { path: '/Reports', element: < Reports />, AccessKey: AccessKeys.Reports, Type: 'read' },
    { path: '/parent-credit-report', element: <ParentCreditReport />, AccessKey: AccessKeys['Parent Credit Report'], Type: 'read' },
    { path: '/teacher-manual-adjustment-report', element: <TeacherManualAdjustmentReport />, AccessKey: AccessKeys['Teacher Manual Adjustment Report'], Type: 'read' },
    { path: '/Batch-Finish-Report', element: <BatchFinishedReport />, AccessKey: AccessKeys['Batch Finished Report'], Type: 'read' },
    { path: '/total-customer-report', element: <TotalCustomerReport />, AccessKey: AccessKeys['Total Customer Report'], Type: 'read' },
    { path: '/bulk-payouts', element: <BulkPayouts />, AccessKey: AccessKeys.BulkPayout, Type: 'read' },
    { path: '/payout-details', element: <PayoutDetails />, AccessKey: AccessKeys.BulkPayout, Type: 'read' },
    { path: '/CreateBulk', element: <CreateBulk />, AccessKey: AccessKeys.BulkPayout, Type: 'read' },
    { path: '/demo-class-details', element: < DemoClassesDetails />, AccessKey: AccessKeys["Demo Classes"], Type: 'read' },
    { path: '/ActivityLog', element: <ActivityLog />, AccessKey: true, Type: 'read' },


]